import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import TablePaginationActions from "../../shared/components/Table/Actions";
import Loading from "../UI/Loading";

/**
 * Lista de alunos. `pagination` é a página da API ({ size, totalElements, number });
 * sem ela (resultado de busca) a tabela não pagina.
 */
const AlunoTable = ({ alunos, pagination, handleChangePage, setAluno, isLoading, emptyText }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando alunos..." />
      </Box>
    );
  }

  if (alunos.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <SchoolOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          {emptyText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" sx={{ minWidth: 560 }} aria-label="Lista de alunos">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell sx={{ width: 120 }}>Código</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Usuário Aluno</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alunos.map((aluno) => (
              <TableRow key={aluno.codigo} hover onClick={() => setAluno(aluno)} sx={{ cursor: "pointer" }}>
                <TableCell>{aluno.codAlunoEscola || "--"}</TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {aluno.nome}
                  </Typography>
                </TableCell>
                <TableCell>
                  {aluno.usuarioAluno?.email ?? (
                    <Typography variant="body2" color="text.disabled" component="span">
                      Sem usuário
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={pagination.size || 0}
          component="div"
          count={pagination.totalElements}
          page={pagination.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
          }
          ActionsComponent={TablePaginationActions}
        />
      )}
    </Box>
  );
};

export default AlunoTable;
